import React from 'react';
import typing from "../Lotties/typing.json"
import Lottie from 'lottie-react'

const Contact = () => {
    return (
        <div>
            <div>
                <h1 className='text-center text-4xl font-bold mt-20 mb-10'>Contact Us</h1>
            </div>
            <div className="grid max-w-screen-xl grid-cols-1 gap-8 px-8 py-16 mx-auto rounded-lg md:grid-cols-2 md:px-12 lg:px-16 xl:px-32 bg-indigo-500">
	<div className="flex flex-col justify-between">
		<div className="space-y-2">
			<h2 className="text-4xl font-bold leading-tight lg:text-5xl text-white">Let's talk!</h2>
			<div className="text-white">Send us your message.</div>
		</div>
		<Lottie animationData={typing}></Lottie>
	</div>
	<form  action="https://formsubmit.co/ullahtarik300@gmail.com" method="POST" className="space-y-6 ng-untouched ng-pristine ng-valid">
		<div>
			<label for="name" className="text-sm text-white">Full name</label>
			<input id="name" type="text" placeholder="" className="w-full p-3 rounded bg-white" required />
		</div>
		<div>
			<label for="email" className="text-sm text-white">Email</label>
			<input id="email" type="email" className="w-full p-3 rounded bg-white" required />
		</div>
		<div>
			<label for="message" className="text-sm text-white">Message</label>
			<textarea id="message" rows="3" className="w-full p-3 rounded bg-white" required></textarea>
		</div>
		<button type="submit" className="w-full p-3 text-sm font-bold tracking-wide uppercase rounded bg-white dark:text-gray-900">Send Message</button>
	</form>
</div>
        </div>
    );
};

export default Contact;